import React from 'react';

import RenderDropdown from 'forms/RenderDropdown';
import { Field } from 'react-final-form';
import { FERTILIZER_EVENT_APPLICATION_METHOD_OPTIONS } from './constants';

export interface Props {
    name: string;
    validate?: any;
    nullOnUnmount?: boolean;
}

export default function FertilizerEventApplicationMethodDropdown(
    props: Props
): React.ReactElement {
    const { name, validate, nullOnUnmount = false } = props;

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            label="Application method"
            placeholder="Select an app. method"
            fluid
            search
            selection
            clearable
            selectOnBlur={false}
            validate={validate}
            options={FERTILIZER_EVENT_APPLICATION_METHOD_OPTIONS}
            nullOnUnmount={nullOnUnmount}
        />
    );
}
